import { useState } from "react";
import { sendContactEmail } from "../lib/firebase";
import { Icon } from "./Icons";

type State = "idle" | "loading" | "success" | "error";

const INPUT_STYLE: React.CSSProperties = {
  width: "100%",
  fontFamily: "var(--font-ui)",
  fontSize: 14,
  padding: "10px 14px",
  border: "1px solid var(--line-2)",
  borderRadius: "var(--radius)",
  background: "#fff",
  color: "var(--ink)",
  outline: "none",
  transition: "border-color .12s",
};

export function ContactForm({ initialMessage = "" }: { initialMessage?: string } = {}) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(initialMessage);
  const [state, setState] = useState<State>("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setState("loading");
    const result = await sendContactEmail({ name, email, message });
    if (result.success) {
      setState("success");
      setName("");
      setEmail("");
      setMessage("");
    } else {
      setState("error");
      setErrorMsg(result.error ?? "Something went wrong. Please try again.");
    }
  };

  if (state === "success") {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: 10,
          padding: "14px 16px",
          background: "#EAF3EC",
          border: "1px solid #BFD8C2",
          borderRadius: "var(--radius)",
          color: "var(--ok)",
          fontSize: 14,
          lineHeight: 1.5,
        }}
      >
        <Icon.Check style={{ flexShrink: 0, marginTop: 2 }} />
        <span>
          Message sent. We'll be in touch shortly — usually within one business day.
        </span>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} style={{ display: "grid", gap: 10 }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <input
          required
          type="text"
          placeholder="Your name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={INPUT_STYLE}
          onFocus={(e) => (e.currentTarget.style.borderColor = "var(--accent)")}
          onBlur={(e) => (e.currentTarget.style.borderColor = "var(--line-2)")}
        />
        <input
          required
          type="email"
          placeholder="you@company.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={INPUT_STYLE}
          onFocus={(e) => (e.currentTarget.style.borderColor = "var(--accent)")}
          onBlur={(e) => (e.currentTarget.style.borderColor = "var(--line-2)")}
        />
      </div>
      <textarea
        required
        placeholder="Tag count, scan rate, what the script computes…"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={4}
        style={{
          ...INPUT_STYLE,
          resize: "vertical",
          fontFamily: "var(--font-mono)",
          fontSize: 13,
          lineHeight: 1.55,
        }}
        onFocus={(e) => (e.currentTarget.style.borderColor = "var(--accent)")}
        onBlur={(e) => (e.currentTarget.style.borderColor = "var(--line-2)")}
      />
      {state === "error" && (
        <div style={{ fontSize: 13, color: "var(--danger)" }}>{errorMsg}</div>
      )}
      <button
        className="btn btn-primary"
        type="submit"
        disabled={state === "loading"}
        style={{ justifySelf: "start" }}
      >
        {state === "loading" ? "Sending…" : "Send message"}
      </button>
    </form>
  );
}
